/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IFavoriteCountsSchema } from '../../entities/favorite_counts/FavoriteCountsSchema';
import { IFavoriteEntityForDesktopSchema } from '../../entities/favorite_entity_for_desktop/FavoriteEntityForDesktopSchema';
import { IFolderResponseSchema } from '../../entities/user_folder/FolderResponseSchema';

export type TWebGetUserFavoritesModel = IModel<IWebGetUserFavoritesRequest, TWebGetUserFavoritesResponse>;

export interface IWebGetUserFavoritesRequest {
  /** Тип сделки **/
  dealType?: EDealType | null;
  /** Тип объявления **/
  entityTypes?: EEntityTypes[] | null;
  /** id подборки **/
  folderId?: number | null;
  /** Кол-во объявлений в ответе **/
  limit?: number | null;
  /** Offset для пагинации по объявлениям **/
  offset?: number | null;
  /** Поле для сортировки **/
  orderField?: EOrderField | null;
  /** Порядок сортировки **/
  orderType?: EOrderType | null;
}

export type TWebGetUserFavoritesResponse = IWebGetUserFavoritesResponse200 | IWebGetUserFavoritesResponse400;

export interface IWebGetUserFavoritesResponse200 extends IModelResponse<IWebGetUserFavoritesResponse> {
  statusCode: 200;
}

export interface IWebGetUserFavoritesResponse400 extends IModelResponse<IWebGetUserFavoritesResponseError> {
  statusCode: 400;
}

export interface IWebGetUserFavoritesResponse {
  /** Есть ли еще избранное, не попавшее на страницу **/
  canLoadMore: boolean;
  /** Комментарий клиента к расшаренной подборке **/
  clientCommentToFolder?: string | null;
  /** Кол-во объектов в избранном по типам **/
  counts: IFavoriteCountsSchema;
  /** Список объектов избранного **/
  favoriteEntities: IFavoriteEntityForDesktopSchema[];
  /** Количество подборок у пользователя **/
  folderCount: number;
  /** Подборки пользователя **/
  folders?: IFolderResponseSchema[] | null;
}

export interface IWebGetUserFavoritesResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IWebGetUserFavoritesResponse | IWebGetUserFavoritesResponseError;

export enum EDealType {
  /** Аренда **/
  Rent = 'rent',
  /** Продажа **/
  Sale = 'sale',
}

export enum EEntityTypes {
  /** Коммерческая **/
  Commercial = 'commercial',
  /** ЖК **/
  Newbuilding = 'newbuilding',
  /** Жилая **/
  Residential = 'residential',
  /** Загородка **/
  Suburban = 'suburban',
}

export enum EOrderField {
  /** По дате добавлению в избранное **/
  Added = 'added',
  /** По дате создания объявления **/
  Created = 'created',
  /** По цене **/
  Price = 'price',
}

export enum EOrderType {
  /** По возрастанию **/
  Asc = 'asc',
  /** По убыванию **/
  Desc = 'desc',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IWebGetUserFavoritesResponse): TResponse200;
  400(response: IWebGetUserFavoritesResponseError): TResponse400;
}
